var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var Menu_1 = __importDefault(require("./Menu"));
exports.Menu = Menu_1.default;
exports.default = Menu_1.default;
//# sourceMappingURL=index.js.map